import api from '@/api/api';
import { IPaidItem, IPayInfo, IPaymentItem, IRequestPay } from '@/models/payment';
import { ApiPayments } from '.';
import { AxiosResponse } from 'axios';
import { IResponseData, ResultDatas } from '@/models/common';
import getApiResponse from '@/api/apiResponse';

export const PaymentService = {
  readyNicePayScript: () => {
    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'https://pay.nicepay.co.kr/v1/js/');
    document.head.appendChild(recaptchaScript);
  },
  nicepayRequestPay: (p: IRequestPay) => {
    window.AUTHNICE.requestPay(p);
  },
  get: async (requestKey: number) => {
    const params = { key: requestKey };

    return await api.get(ApiPayments.GET, { params });
  },
  getReady: async (refKey: number) => {
    const params = { key: refKey };
    const res: AxiosResponse<IResponseData<IPayInfo>> = await api.get(ApiPayments.GET_READY, { params });
    return getApiResponse<IPayInfo>(res);
  },
  getMyPaidList: async () => {
    const res: AxiosResponse<IResponseData<Array<IPaymentItem>>> = await api.post(ApiPayments.GET_MY_PAIDLIST);
    return getApiResponse<Array<IPaymentItem>>(res);
  },
  getRequestKey: async (key: string) => {
    const params = { key };
    const res: AxiosResponse<IResponseData<string>> = await api.get(ApiPayments.GET_REQUEST_KEY, { params });
    return getApiResponse<string>(res);
  },
  getPaidItem: async (key: string) => {
    const params = { key };
    const res: AxiosResponse<IResponseData<IPaidItem>> = await api.get(ApiPayments.GET_PAID, { params });
    return getApiResponse<IPaidItem>(res);
  },
  saveNice: async (OrderId: String) => {
    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiPayments.SAVE_NICE, { OrderId });
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },
};
export default PaymentService;
